import script from "./BuyTicketButton.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyTicketButton.vue?vue&type=script&setup=true&lang=js"

import "./BuyTicketButton.vue?vue&type=style&index=0&id=8e4b7d38&lang=css"

const __exports__ = script;

export default __exports__